// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1UjRj","content":"styles_content__1H3z_","checkbox":"styles_checkbox__1w6AI","checkboxLabel":"styles_checkboxLabel__3y5iy"};